<template>
  <div class="to-user text-dark">

    <h1 class="to-user__headline" :class="{'only-print': !showHeadline}">{{ user.name }}, {{ schoolYear }}<span class="to-d-pill" v-if="version.vTitle">{{
        version.vTitle
      }}</span></h1>
    <!-- NORM -->
    <table class="d-table marg-1-bottom d-table__overview" v-if="userNorm.length > 0">
      <thead>
      <tr>
        <th><h4>{{ $t('vue2.task_versions.annual_norm') }}</h4></th>
        <th class="is-number"></th>
      </tr>
      </thead>
      <tbody>
      <tr v-for="(item, idx) in userNormFormatted" v-if="idx < userNormFormatted.length - 1" :key="item.title">
        <td>{{ item.title }}</td>
        <td class="is-number">{{ item.value }}</td>
      </tr>
      </tbody>
      <tfoot>
      <tr v-for="(item, idx) in userNormFormatted" v-if="idx === userNormFormatted.length - 1" :key="item.title">
        <td>{{ item.title }}</td>
        <td class="is-number">{{ item.value }}</td>
      </tr>
      </tfoot>
    </table>
    <!-- FORDELING -->
    <table class="d-table marg-1-bottom d-table__overview" v-if="Object.keys(userPoolsFormatted).length > 0">
      <thead>
      <tr>
        <th><h4>{{ i18n['pools'] }}</h4></th>
        <th class="is-number">{{ $t('vue2.assign_users_hours.assigned') }}</th>
      </tr>
      </thead>
      <tbody>
      <tr v-for="(pool, prop) in userPoolsFormatted">
        <td>{{ prop }}</td>
        <td class="is-number">
          {{ pool }}
        </td>
      </tr>
      <tr v-if="rest">
        <td>Rest</td>
        <td class="is-number">
          {{ rest }}
        </td>
      </tr>
      </tbody>
    </table>
    <UserTasksOverviewOwnPools
      v-if="schoolSettingShownOwnPools && schoolSettingShownOwnPools.length > 0"
      :schoolSettingShownOwnPools="schoolSettingShownOwnPools"
      :isShowScheduled="false"
      :userTasks="tasksByMasterType">
    </UserTasksOverviewOwnPools>
    <!-- TASKS -->
    <TaskOverviewUserTasks
      v-if="tasksByMasterType && tasksByMasterType.length > 0"
      :user="user"
      :tasks="tasks"
      :tasksByMasterType="tasksByMasterType"
      :schoolThresholdToHideTaskHours="schoolThresholdToHideTaskHours"
      :isHideTaskHoursUnderThreshold="isHideTaskHoursUnderThreshold"
      :canEditTasks="canEditTasks"
      @editTask="onEditTask">
    </TaskOverviewUserTasks>
    <!-- Agreements: live-visning bruger samme editor som Timeopgørelsen -->
    <SubjectsDistributionUserAgreements
      v-if="canEditNotes && userIdNumber"
      :userId="userIdNumber"
      :userAgreements="userAgreements"
      :isReadAgreements="false">
    </SubjectsDistributionUserAgreements>
    <div class="to-agreements" v-else-if="userAgreements && userAgreements.length > 0">
      <div class="to-agreements__header">
        <h4>{{ i18n['notes'] }}</h4>
      </div>
      <div class="to-agreements__body" v-html="userAgreements"></div>
    </div>
  </div>
</template>

<script>
import UserTasksOverviewOwnPools from '../UserTasksOverviewOwnPools.vue'
import SubjectsDistributionUserAgreements from '../../SubjectsDistribution/SubjectsDistributionUserAgreements.vue'

const I18N = {
  da: {
    assigned_total_hours: 'Arbejdstid',
    assigned_teaching_hours: 'Undervisning',
    assigned_preparation_hours: 'Forberedelse',
    assigned_additional_task_hours: 'Øvrige opgaver',
    assigned_pool_hours: 'Lokalpulje',
    assigned_club_hours: 'SFO timer',
    substitute_pool_hours: 'Vikartimer',
    notes: 'Noter/særlige aftaler',
    pools: 'Fordeling'
  },
  nb: {
    assigned_total_hours: 'Arbeidstid',
    assigned_teaching_hours: 'Undervisning',
    assigned_preparation_hours: 'Forberedelse',
    assigned_additional_task_hours: 'Oppgaver',
    substitute_pool_hours: 'Vikartimer',
    assigned_pool_hours: 'Planegginsdager',
    assigned_club_hours: 'SFO timer',
    notes: 'Noter/særlige aftaler',
    pools: 'Puljer'
  },
  en: {
    assigned_club_hours: 'Club Hours',
    assigned_pool_hours: 'Local pool',
    assigned_total_hours: 'Work time',
    substitute_pool_hours: 'Substitute hours',
    assigned_teaching_hours: 'Teaching',
    assigned_preparation_hours: 'Preparation',
    assigned_additional_task_hours: 'Additional tasks',
    notes: 'Notes',
    pools: 'Pools'
  }
}
import TaskOverviewUserTasks from './TaskOverviewUserTasks'
import {parseNumericPreparationFactor, effectivePreparationFactor} from '../../../utils/preparationFactor'
import {
  effectiveAssignedPoolFromNormWhenPoolsDeactivated,
  effectiveDeactivatePoolsFromVersion,
  effectivePrepFactorFromVersion
} from '../../../utils/taskOverviewSnapshot'

export default {
  components: {UserTasksOverviewOwnPools, TaskOverviewUserTasks, SubjectsDistributionUserAgreements},
  props: {
    user: {},
    version: {
      default: () => null
    },
    isHideTaskHoursUnderThreshold: {
      default: false
    },
    showHeadline: {
      type: Boolean,
      default: true
    },
    canEditTasks: {
      type: Boolean,
      default: false
    },
    canEditNotes: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      isShowScheduled: false
    }
  },
  computed: {
    locale () {
      return this.$store.getters.locale
    },
    i18n () {
      return Object.assign({}, I18N[this.locale], {
        assigned_pool_hours: this.localPoolTitle
      })
    },
    localPoolTitle () {
      const title = this.$store.getters.localPoolTitle
      return title || this.$t('vue2.task_overview.pool')
    },
    schoolCustomData () {
      return this.version && this.version.overview && this.version.overview.school_custom_data
    },
    isPoolsDeactivated () {
      return effectiveDeactivatePoolsFromVersion(this.version, this.schoolSettings)
    },
    isAssignedPoolFromNormWhenPoolsDeactivated () {
      return effectiveAssignedPoolFromNormWhenPoolsDeactivated(this.version, this.schoolSettings)
    },
    schoolThresholdToHideTaskHours () {
      return this.schoolCustomData ? this.schoolCustomData.thresholdToHideTaskHours : null
    },
    schoolSettingShownOwnPools () {
      return this.schoolCustomData ? this.schoolCustomData.shownOwnPools : []
    },
    schoolSettings () {
      return this.$store.state.schoolSettings
    },
    schoolSettingPrepFactor () {
      return effectivePrepFactorFromVersion(this.version, this.schoolSettings)
    },
    isPrepFactorForSubstitutePools () {
      return !!(this.schoolSettings && this.schoolSettings.prepFactorForSubstitutePools)
    },
    /**
     * Forberedelse af vikarpuljen (budget-tallet i overview.pools) når
     * prepFactorForSubstitutePools er aktiv. Ellers 0.
     */
    substitutePoolPreparationHours () {
      if (!this.isPrepFactorForSubstitutePools || this.isUserInGroupWithoutPrepFactor) {
        return 0
      }
      const schoolPrep = parseNumericPreparationFactor(this.schoolSettingPrepFactor)
      if (schoolPrep === null) {
        return 0
      }
      const substituteHours = this.userPools ? parseFloat(this.userPools.substitute_pool_hours) : NaN
      if (isNaN(substituteHours)) {
        return 0
      }
      return parseFloat((substituteHours * schoolPrep).toFixed(2))
    },
    schoolCountry () {
      return this.$store.getters.schoolCountry
    },
    userTagsWithoutPrepFactor () {
      return this.$store.getters.userTagsWithoutPrepFactor || []
    },
    isUserInGroupWithoutPrepFactor () {
      if (this.userTagsWithoutPrepFactor.length === 0) {
        return false
      }
      let userTags = this.user && this.user.user_tags
      if (!Array.isArray(userTags)) {
        const storeUser = this.$store.getters.allUsersInHash &&
          this.$store.getters.allUsersInHash[this.user.id]
        userTags = storeUser && storeUser.user_tags
      }
      if (!Array.isArray(userTags)) {
        return false
      }
      return userTags.some(tag => this.userTagsWithoutPrepFactor.includes(tag))
    },
    /**
     * Ved DK + deaktiverede puljer + skole-faktor: sum(UV-timer × effektiv faktor per brik).
     * Grupper uden forberedelsesfaktor får kun eksplicitte forberedelsesopgaver.
     */
    weightedPreparationDisplayHours () {
      if (!this.schoolSettingPrepFactor || !this.isPoolsDeactivated) {
        return null
      }
      if (this.locale !== 'da' || String(this.schoolCountry).toLowerCase() !== 'dk') {
        return null
      }
      const schoolPrep = parseNumericPreparationFactor(this.schoolSettingPrepFactor)
      if (schoolPrep === null) {
        return null
      }
      const skipTeachingFactor = this.isUserInGroupWithoutPrepFactor
      let total = 0
      this.tasksFiltered.forEach(task => {
        if (task.substitute) {
          return
        }
        const isPrepTypeTask = task.subject_type === 'preparation' || task.master_type === 'preparation'
        const isTeachingOnly = task.master_type === 'teaching' && !isPrepTypeTask
        if (!isPrepTypeTask && !isTeachingOnly) {
          return
        }
        const hours = parseFloat(task.hours)
        const h = isNaN(hours) ? 0 : hours
        if (isPrepTypeTask) {
          const factor = parseNumericPreparationFactor(task.preparation)
          if (factor !== null) {
            total += h * factor
          }
        } else if (!skipTeachingFactor) {
          const factor = effectivePreparationFactor(task.preparation, schoolPrep)
          total += h * factor
        }
      })
      return parseFloat(total.toFixed(2))
    },
    schoolYears () {
      return this.$store.state.schoolYears
    },
    schoolYear () {
      if (!this.version || !this.version.school_year_id) {
        return ''
      }
      const idx = this.schoolYears.findIndex(schoolYear => schoolYear.id === this.version.school_year_id)
      return idx > -1 ? this.schoolYears[idx]['name'] : ''
    },
    userIdNumber () {
      return this.user && this.user.id ? this.user.id * 1 : null
    },
    userAgreements () {
      return this.version.overview && this.version.overview.agreements ? this.version.overview.agreements : ''
    },
    userNorm () {
      return this.version.overview.norm
    },
    userNormFormatted () {
      if (Object.keys(this.userNorm).length < 1) {
        return []
      }
      const normsFiltered = this.userNorm.filter(item => item.title.indexOf('hidden_') < 0)
      return normsFiltered.map(item => ({
        ...item,
        value: item.value
      }))
    },
    userPools () {
      return this.version.overview.pools
    },
    taskPools () {
      const result = {}

      // Hjælpefunktion til at formatere timer
      const formatHours = value => (value || value === 0 ? value.toFixed(2) : '0.00')

      // Først arbejdstid
      const totalWorkHours = this.userPools['assigned_total_hours']
      const translatedKey = this.i18n['assigned_total_hours'] || 'assigned_total_hours'
      const translatedPrep = this.i18n['assigned_preparation_hours']
      result[translatedKey] = formatHours(totalWorkHours)

      // Så alle brikker og puljer
      const taskTypes = this.schoolSettingPrepFactor ? this.tasksByOriginalType.filter(taskType => taskType.originalType !== 'preparation') : this.tasksByOriginalType
      let hasPrepRow = false
      taskTypes.forEach(taskType => {
        if (this.schoolSettingPrepFactor && taskType.originalType === 'teaching') {
          const prepHours = (this.weightedPreparationDisplayHours !== null
            ? this.weightedPreparationDisplayHours
            : taskType.totalHours * this.schoolSettingPrepFactor) + this.substitutePoolPreparationHours
          result[translatedPrep] = formatHours(prepHours)
          hasPrepRow = true
        }
        result[taskType.title] = formatHours(taskType.totalHours)
      })
      // Uden undervisningsbrikker skal eksplicitte forberedelsesbrikker
      // (fx "medregnes ud over forberedelsesfaktor") og vikar-forberedelse
      // stadig vises som Forberedelse
      if (this.schoolSettingPrepFactor && !hasPrepRow) {
        const prepWithoutTeaching = (this.weightedPreparationDisplayHours !== null ? this.weightedPreparationDisplayHours : 0) +
          this.substitutePoolPreparationHours
        if (prepWithoutTeaching !== 0) {
          result[translatedPrep] = formatHours(prepWithoutTeaching)
        }
      }
      return result
    },
    userPoolsFormatted () {
      if (this.isPoolsDeactivated) {
        const result = Object.assign({}, this.taskPools)
        if (this.isAssignedPoolFromNormWhenPoolsDeactivated) {
          const poolHours = this.userPools && this.userPools.assigned_pool_hours
          if (poolHours !== null && poolHours !== undefined && poolHours !== 0) {
            result[this.i18n.assigned_pool_hours] = (poolHours || poolHours === 0 ? poolHours : 0).toFixed(2)
          }
        }
        // Vikarpuljen er et budget-tal fra årsnormen (ikke en brik) og vises derfor
        // som egen række, når forberedelsesfaktor for vikarpuljer er aktiv — så
        // fordelingen og Rest matcher Årsnorm-siden og Timeopgørelsen
        if (this.isPrepFactorForSubstitutePools) {
          const substituteHours = this.userPools && this.userPools.substitute_pool_hours
          if (substituteHours !== null && substituteHours !== undefined && substituteHours !== 0) {
            result[this.i18n.substitute_pool_hours] = Number(substituteHours).toFixed(2)
          }
        }
        return result
      }
      let result = {}
      // Create an array to hold the translated keys with their original order
      let translatedKeys = []
      for (let key in this.userPools) {
        if (this.userPools[key] !== null && this.userPools[key] !== 0) {
          let translatedKey = this.i18n[key] || key
          translatedKeys.push({key: translatedKey, originalKey: key})
        }
      }
      // Sort the translated keys based on the hierarchy in this.i18n
      translatedKeys.sort((a, b) => {
        return (
          Object.keys(this.i18n).indexOf(a.originalKey) -
          Object.keys(this.i18n).indexOf(b.originalKey)
        )
      })
      // Build the result object with sorted keys
      for (let item of translatedKeys) {
        result[item.key] = this.userPools[item.originalKey].toFixed(2)
      }
      return result
    },
    totalUserPools () {
      const poolsObj = this.isPoolsDeactivated ? this.userPoolsFormatted : this.userPools
      let sum = 0
      for (const key in poolsObj) {
        if (key !== 'assigned_total_hours' && key !== this.i18n['assigned_total_hours']) {
          const value = poolsObj[key]
          const num = Number(value)
          if (!isNaN(num)) {
            sum += num
          }
        }
      }
      return sum
    },
    rest () {
      if (this.userPools.assigned_total_hours && this.userPools.assigned_total_hours > 0) {
        const remainingHours = this.userPools.assigned_total_hours - this.totalUserPools
        return remainingHours.toFixed(2)
      }
    },
    tasks () {
      return this.version.overview.tasks
    },
    tasksFiltered () {
      return this.tasks.filter(item => item.master_type !== 'unknown')
    },
    tasksByMasterType () {
      let pools = {}

      // Helper til at sikre tal og fallback til 0
      function getValidHours (val) {
        let num = parseFloat(val)
        return isNaN(num) ? 0 : num
      }

      this.tasksFiltered.forEach(task => {
        let hours = getValidHours(task.hours)

        // Skip hvis task ikke er actual og hours == 0, og der findes duplikater
        if (!task.actual && hours === 0) {
          let sameIdTasks = this.tasksFiltered.filter(t => t.id === task.id)
          if (sameIdTasks.length > 1) {
            return
          }
        }

        let activeType = task.task_category_name ? task.task_category_name : task.master_type

        if (task.substitute) {
          activeType = 'substitute_hours'
        }

        let title = this.getMasterTypeTitle(activeType)

        if (!pools[title]) {
          pools[title] = {
            originalType: activeType,
            rank: task.substitute ? null : this.getTaskCategoryRank(task),
            tasks: [],
            totalHours: 0.0
          }
        }

        pools[title].tasks.push(task)
        pools[title].totalHours += hours
      })

      for (let pool in pools) {
        pools[pool].tasks.sort((a, b) => this.compareTasksForOverview(a, b))
      }

      let poolsArray = Object.entries(pools).map(([title, { originalType, rank, tasks, totalHours }]) => ({
        title: title === 'substitute_hours' ? this.getMasterTypeTitle('substitute_hours') : title,
        originalType,
        rank,
        tasks,
        totalHours
      }))

      poolsArray.sort((a, b) => this.getPoolSortOrder(a) - this.getPoolSortOrder(b))

      return poolsArray.filter(pool => pool.originalType !== 'absence')
    },

    tasksByOriginalType () {
      let pools = {}

      function getValidHours (val) {
        let num = parseFloat(val)
        return isNaN(num) ? 0 : num
      }

      this.tasksFiltered.forEach(task => {
        let hours = getValidHours(task.hours)
        let masterTypeTitle = this.getMasterTypeTitle(task.master_type)

        if (!pools[masterTypeTitle]) {
          pools[masterTypeTitle] = {
            originalType: task.master_type,
            rank: this.getTaskCategoryRank(task),
            tasks: [],
            totalHours: 0.0
          }
        }

        pools[masterTypeTitle].totalHours += hours

        if (task.substitute && !pools['substitute_hours']) {
          pools['substitute_hours'] = {
            originalType: 'substitute_hours',
            rank: null,
            tasks: [task],
            totalHours: hours
          }
        } else if (task.substitute) {
          pools['substitute_hours'].tasks.push(task)
          pools['substitute_hours'].totalHours += hours
        } else {
          pools[masterTypeTitle].tasks.push(task)
        }
      })

      for (let pool in pools) {
        pools[pool].tasks.sort((a, b) => this.compareTasksForOverview(a, b))
      }

      let poolsArray = Object.entries(pools).map(([title, {originalType, rank, tasks, totalHours}]) => ({
        title: title === 'substitute_hours' ? this.getMasterTypeTitle('substitute_hours') : title,
        originalType,
        rank,
        tasks,
        totalHours
      }))

      poolsArray.sort((a, b) => this.getPoolSortOrder(a) - this.getPoolSortOrder(b))

      return poolsArray.filter(pool => pool.originalType !== 'absence')
    },
    sortOrder () {
      return {
        teaching: 0,
        substitute_hours: 1,
        other: 2,
        preparation: 3,
        club: 4,
        absence: 8,
        unknown: 8,
        with_kids: 0,
        without_kids: 2
      }
    }
  },
  methods: {
    getTaskCategoryRank (task) {
      return (task && task.task_category_rank !== undefined && task.task_category_rank !== null)
        ? task.task_category_rank
        : null
    },
    compareTasksForOverview (a, b) {
      const aIsActivity = a.subject_type === 'activity'
      const bIsActivity = b.subject_type === 'activity'
      if (aIsActivity !== bIsActivity) return aIsActivity ? 1 : -1
      if (a.name < b.name) return -1
      if (a.name > b.name) return 1
      return 0
    },
    getPoolSortOrder (pool) {
      if (pool.rank !== null && pool.rank !== undefined) {
        return pool.rank
      }
      return this.sortOrder[pool.originalType] !== undefined ? this.sortOrder[pool.originalType] : 999
    },
    getMasterTypeTitle (title) {
      switch (title) {
        case 'teaching':
          return this.$t('vue2.task_overview.teaching')
        case 'other':
          return this.$t('vue2.task_overview.tasks')
        case 'preparation':
          return this.$t('vue2.task_overview.preparation')
        case 'absence':
          return this.$t('vue2.task_overview.absence')
        case 'club':
          return this.$t('vue2.task_overview.club')
        case 'substitute_hours':
          return this.$t('vue2.task_overview.substitute_hours')
        case 'pool':
          return this.localPoolTitle
        case 'with_kids':
          return 'Tid med børn'
        case 'without_kids':
          return 'Tid uden børn'
        default:
          return title
      }
    },
    onEditTask (task) {
      this.$emit('editTask', task)
    }
  }
}
</script>


<style scoped>
.to-user {
  background-color: #fff;
  padding: 1rem;
}

@media print {
  .to-user {
    page-break-after: always;
    break-after: page;
  }
  .to-user:last-child {
    page-break-after: auto;
    break-after: auto;
  }
}

.d-table {
  width: 100%;
  border-collapse: collapse;
  border: 1px solid #e2e8f0;
}

.d-table > thead, .d-table > tfoot {
  border: 1px solid #e2e8f0;
  text-transform: uppercase;
  font-weight: bold;
  text-align: left;
  background: #f6f9fc;
}

.d-table > tfoot tr:last-child {
  font-size: 13px;
}

.d-table > thead > tr > th, .d-table > tfoot > tr > td {
  padding: 5px;
}

.d-table > thead > tr:first-child, .d-table > tfoot > tr:first-child {
  color: #8898aa;
}

.d-table tr th, .d-table > tfoot tr td {
  padding: 2px 4px;
}

.d-table tr th h4 {
  color: #3e4450;
}

.d-table tr td {
  padding: 0 4px;
}

.d-table tr td:first-child {
  padding-left: 2rem;
}

.is-number {
  text-align: right;
}

.to-agreements {
  border: 1px solid #e2e8f0;
}

.to-agreements__header {
  text-transform: uppercase;
  font-weight: bold;
  text-align: left;
  background: #f6f9fc;
  padding: 5px;
  border-bottom: 1px solid #e2e8f0;
}

.to-agreements__body {
  padding: 4px 4px 4px 2rem;
}

.to-d-pill {
  border-radius: 4px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  line-height: 1;
  background-color: #fefce8;
  color: #854d0f;
  padding: 4px 8px;
  font-weight: bold;
  border: 1px solid #f4e6c0;
  font-size: 11px;
  margin-left: 1rem;
}

.to-user__headline {
  display: flex;
  align-items: center;
}

</style>



// WEBPACK FOOTER //
// TaskOverviewUser.vue?73445d80